import { useCallback, useState } from 'react';

const useSkeleton = () => {
  const [isLoading, setIsLoading] = useState(true);

  const setSkeletonLoading = useCallback((value: boolean) => {
    setIsLoading(value);
  }, []);

  return { isLoading, setSkeletonLoading };
};

export default useSkeleton;
